var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"timebox"},[_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm.nowDate))]),_c('span',{staticClass:"week"},[_vm._v(_vm._s(_vm.nowWeek))]),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.nowtime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }